/**
 * BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz
 * bxyz-xp-font-hero — cyklar BXYZ PC-typsnittsvarianter
 */

(function () {
  const INTERVALL_MS = 1000;
  const laddadeFamiljer = new Set();

  function hamtaVarianter(sektion) {
    const karta = sektion.querySelector('[data-xp-font-karta]');
    if (!karta) return [];
    try {
      return JSON.parse(karta.textContent);
    } catch {
      return [];
    }
  }

  function laddaVariant(variant) {
    if (!variant || !variant.u || !variant.f) return Promise.resolve();
    if (laddadeFamiljer.has(variant.f)) return Promise.resolve();
    if (!window.FontFace) return Promise.resolve();

    return laddaFontUrl(variant, variant.u).catch(function () {
      if (variant.u.endsWith('.TTF')) {
        return laddaFontUrl(variant, variant.u.replace(/\.TTF$/, '.ttf'));
      }
      if (variant.u.endsWith('.ttf')) {
        return laddaFontUrl(variant, variant.u.replace(/\.ttf$/, '.woff'));
      }
      return undefined;
    }).catch(function () {
      return undefined;
    });
  }

  function laddaFontUrl(variant, url) {
    const descriptors = {
      style: 'normal',
      display: 'swap'
    };

    if (variant.vf) {
      descriptors.weight = '100 900';
    } else {
      descriptors.weight = '400';
    }

    const face = new FontFace(variant.f, `url(${url})`, descriptors);

    return face.load().then(function (loaded) {
      document.fonts.add(loaded);
      laddadeFamiljer.add(variant.f);
    });
  }

  function initSektion(sektion) {
    const exempel = sektion.querySelector('[data-xp-font-exempel]');
    const variantEtikett = sektion.querySelector('[data-xp-font-variant]');
    const varianter = hamtaVarianter(sektion);
    if (!exempel || !variantEtikett || !varianter.length) return;

    const standardText = exempel.textContent;
    let index = 0;
    const reduceradRorelse = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function visaVariant(nyIndex) {
      const variant = varianter[nyIndex];
      const text = variant.t || standardText;
      exempel.dataset.variant = String(variant.i);
      exempel.dataset.textlage = text.length > 40 ? 'lang' : 'kort';
      exempel.textContent = text;
      variantEtikett.textContent = variant.l;
      exempel.setAttribute('aria-label', `BXYZ PC — ${variant.l}`);
      laddaVariant(variant);
    }

    function bytVariant() {
      exempel.dataset.tillstand = 'byts';
      requestAnimationFrame(function () {
        index = (index + 1) % varianter.length;
        visaVariant(index);
        delete exempel.dataset.tillstand;
      });
    }

    laddaVariant(varianter[0]).finally(function () {
      visaVariant(0);

      if (!reduceradRorelse) {
        const timer = window.setInterval(bytVariant, INTERVALL_MS);
        sektion._xpFontTimer = timer;
      }

      varianter.forEach(function (variant, i) {
        if (i > 0) laddaVariant(variant);
      });
    });
  }

  function rensaSektion(sektion) {
    if (sektion._xpFontTimer) {
      window.clearInterval(sektion._xpFontTimer);
      delete sektion._xpFontTimer;
    }
  }

  function init() {
    document.querySelectorAll('[data-xp-font-hero]').forEach(initSektion);
  }

  document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', function (event) {
    const sektion = event.target.querySelector('[data-xp-font-hero]');
    if (sektion) initSektion(sektion);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const sektion = event.target.querySelector('[data-xp-font-hero]');
    if (sektion) rensaSektion(sektion);
  });
})();
